"use client";

import { Bookmark } from "lucide-react";
import { cn } from "@/lib/utils";

export type SaveContentType =
  | "destination"
  | "attraction"
  | "hotel"
  | "restaurant"
  | "experience"
  | "event"
  | "itinerary";

interface SaveButtonProps {
  type: SaveContentType;
  id: string;
  saved: boolean;
  onToggle: (type: SaveContentType, id: string) => void;
  label?: string;
  savedLabel?: string;
  className?: string;
}

export function SaveButton({
  type,
  id,
  saved,
  onToggle,
  label = "Save",
  savedLabel = "Saved",
  className,
}: SaveButtonProps) {
  return (
    <button
      type="button"
      onClick={() => onToggle(type, id)}
      aria-pressed={saved}
      aria-label={saved ? savedLabel : label}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-medium transition-colors",
        saved
          ? "border-pine bg-pine/10 text-pine"
          : "border-mist bg-white/80 text-ridge hover:border-pine/30 hover:text-pine",
        className,
      )}
    >
      <Bookmark
        className={cn("size-4", saved && "fill-current")}
        aria-hidden
      />
      <span>{saved ? savedLabel : label}</span>
    </button>
  );
}
